<nav aria-label="Breadcrumb Navigation" *ngIf="showBreadcrumbs">
  <ol class="breadcrumbs">
    @for (breadcrumb of breadcrumbs; track breadcrumb.url) {
      <li class="breadcrumb-item">
        <a class="breadcrumb-link" routerLink="{{ breadcrumb.url }}">{{ breadcrumb.label }}</a>
        <svg-icon class="breadcrumb-icon" src="assets/images/icons/chevron_right.svg"></svg-icon>
      </li>
    }
  </ol>
</nav>
